import {MedicationProfileFormSchema} from '@/modules/drug-catalog/medication-profiles/schemas'
import {SortSchema} from '@cypro/ui/schemas'
import {DoseCalcModeActive, OverdosePreventionLevel, RoundingMode} from '@cypro/engine/database/schema'
import {AddSupportiveMedicationSchema} from '@cypro/engine/mutators'
import * as z from 'zod'

export const NewSupportiveMedicationPageSearchSchema = z.object({
  drugId: z.uuidv7().optional(),
})

export const SupportiveMedicationsSearchSchema = z.object({
  filters: z
    .object({
      search: z.string().optional(),
      categories: z.array(z.uuidv7()).optional(),
      calculationMethod: z.array(DoseCalcModeActive).optional(),
      unit: z.array(z.uuidv7()).optional(),
    })
    .optional(),
  sort: z.array(SortSchema).default([{id: 'name', desc: false}]),
})

export const SupportiveMedicationFormSchema = AddSupportiveMedicationSchema.omit({
  doseCalcMode: true,
  doseUnitId: true,
  roundingMode: true,
  overdosePreventionLevel: true,
  medicationProfiles: true,
}).extend({
  doseCalcMode: z.array(DoseCalcModeActive).nonempty(),
  roundingMode: z.array(RoundingMode).nonempty(),
  overdosePreventionLevel: z.array(OverdosePreventionLevel).nonempty(),
  doseUnitId: z.array(z.uuidv7()).nonempty(),
  medicationProfiles: z.array(MedicationProfileFormSchema).nonempty(),
})

export type SupportiveMedicationFormSchema = z.infer<typeof SupportiveMedicationFormSchema>
